import { get } from 'svelte/store'
import { userStore, pageOptsStore } from '@packages/stores'
import { getAddress } from '@src/passport/blockchain'
import { configStore } from '@src/stores/config'
import { getClientConfigByClientId } from '@lib/clients'
import type { TBasicPaymentData } from '../oders.types'


export const preparePaymentData = async () => {
  const config = get(configStore)
  const paymentOpts = get(pageOptsStore)
  const user = get(userStore)
  const userAddress = await getAddress()

  const email = user?.email || user?.pending?.email
  const phone = user?.phone || user?.pending?.phone
  const description =
    'Passport Payment: ' +
    `(${JSON.stringify({
      ...paymentOpts.tokens,
      ...paymentOpts.memberships,
      ...paymentOpts.licenses,
      userAddress,
      chainId: config.chainId,
      email,
      phone,
    })})`

  const clientName = getClientConfigByClientId(config.clientId).name
  return {
    client: clientName,
    description,
    address: userAddress,
    chain_id: Number(config.chainId),
    client_id: config.clientId,
    payment_provider: 'stripe',
    currency: 'USD',
  } as TBasicPaymentData
}
